import { useNavigate } from 'react-router-dom';
import { settingsSectionPath } from '@/routes/route-config';
import { useTranslation } from 'react-i18next';
import { useSubscription } from '@/hooks/useSubscription';
import { AlertTriangle, X, CreditCard } from 'lucide-react';
import { useState } from 'react';

export function SubscriptionWarningBanner() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    showExpirationWarning,
    isInGracePeriod,
    daysUntilExpiration,
    daysUntilGraceEnds,
  } = useSubscription();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;
  if (!showExpirationWarning && !isInGracePeriod) return null;

  const isGrace = isInGracePeriod;
  const days = isGrace ? daysUntilGraceEnds : daysUntilExpiration;

  return (
    <div
      className={`px-4 sm:px-6 py-2.5 text-small flex items-center justify-center gap-4 print:hidden ${
        isGrace ? 'bg-danger-600 text-white' : 'bg-warning-500 text-white'
      }`}
    >
      <div className="flex items-center gap-2">
        <AlertTriangle className="h-4 w-4 shrink-0" />
        <span>
          {isGrace ? (
            <>
              <strong>{t('subscription.warning.gracePeriodActive')}</strong>{' '}
              <span
                dangerouslySetInnerHTML={{
                  __html: t('subscription.warning.graceDaysRemaining', {
                    days,
                    plural: days !== 1 ? 's' : '',
                  }),
                }}
              />
            </>
          ) : (
            <span
              dangerouslySetInnerHTML={{
                __html: t('subscription.warning.expiresIn', {
                  days,
                  plural: days !== 1 ? 's' : '',
                }),
              }}
            />
          )}
        </span>
      </div>

      <div className="flex items-center gap-2 shrink-0">
        <button
          onClick={() => navigate(settingsSectionPath('subscription'))}
          className="inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-1 rounded-full bg-white/20 hover:bg-white/30 backdrop-blur-sm transition-colors"
        >
          <CreditCard className="h-3.5 w-3.5" />
          {t('subscription.warning.renewNow')}
        </button>
        {!isGrace && (
          <button
            onClick={() => setDismissed(true)}
            className="p-0.5 rounded-full hover:bg-white/20 transition-colors"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        )}
      </div>
    </div>
  );
}
